/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_Q6Inputs */

const en_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is payment handled?`)
};

const de_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird die Zahlung abgewickelt?`)
};

const fr_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a university email for the Student plan?`)
};

const es_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a university email for the Student plan?`)
};

const it_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a university email for the Student plan?`)
};

const nl_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a university email for the Student plan?`)
};

const pl_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a university email for the Student plan?`)
};

const fi_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a university email for the Student plan?`)
};

const da_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a university email for the Student plan?`)
};

const sv_pricing_faq_q6 = /** @type {(inputs: Pricing_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a university email for the Student plan?`)
};

/**
* | output |
* | --- |
* | "How is payment handled?" |
*
* @param {Pricing_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_q6 = /** @type {((inputs?: Pricing_Faq_Q6Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_Q6Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_q6(inputs)
	if (locale === "fr") return fr_pricing_faq_q6(inputs)
	if (locale === "es") return es_pricing_faq_q6(inputs)
	if (locale === "it") return it_pricing_faq_q6(inputs)
	if (locale === "nl") return nl_pricing_faq_q6(inputs)
	if (locale === "pl") return pl_pricing_faq_q6(inputs)
	if (locale === "fi") return fi_pricing_faq_q6(inputs)
	if (locale === "da") return da_pricing_faq_q6(inputs)
	if (locale === "sv") return sv_pricing_faq_q6(inputs)
	return en_pricing_faq_q6(inputs)
});